import React, {Component} from 'react';
import '../styles/introduction.css';

class Introduction extends Component {
    render() {
        return (
            <div className="introductionContainer" id="introduction">
                <div className="introductionTitle">
                    Introduction
                </div>
                <div className="introductionText">
                    I am a technology enthusiast working in software development for over 6 years, who enjoys learning new stuff and solve problems. I am constantly trying to increase my knowleadge base and improving my work processes.
                    I am also a DIY fan and am always seeking things that I can buid or fix myself to improve mine and other lifes.

                </div>

            </div>
        );
    }
}

export default Introduction;
